
    var riot = require('riot')
    
riot.tag2('availability-cal', '<div if="{!window.location.search.match(/editmode/)}"> <div class="row"> <div class="col-md-3 col-sm-6 col-xs-12"> <div class="calbox"> <datepicker date="{new Date()}" onupdate="{handledatechange}" datestyle="{datestyle}"> </datepicker> <div class="busy"></div>Busy </div> </div> <div if="{today &lt;= new Date()}" class="col-md-9 col-sm-6col-xs-12"> <h4>Sorry, you cannot arrange meetings in the past</h4> <p>Please choose another date.</p> </div> <div if="{today.getDay()==6 || today.getDay()==0}" class="col-md-9 col-sm-6col-xs-12"> <h4>Sorry, you cannot arrange meetings on a weekend</h4> <p>Please choose another date.</p> </div> <div if="{today &gt; new Date() &amp;&amp; today.getDay()&lt;6 &amp;&amp; today.getDay()&gt;0}" class="col-md-9 col-sm-6 col-xs-12"> <h4>Approx Availability for <dateformat date="{today}" format="dd MMMM yyyy"></dateformat> </h4> <div class="day"> <div each="{hr, i in opening}" onclick="{choosetime.bind(null,hr)}" class="hours {hourfree(hr)}">{hr}:00</div> </div> </div> <hr> <div class="col-lg-8 col-lg-offset-2 col-md-12"> <form action="/duocms/api/formsend" method="POST" enctype="multipart/form-data" class="form-horizontal"> <input type="hidden" name="_csrf" value="{opts.csrf}"> <input type="text" name="duoreform{duoreform}" value="" style="display: none;"> <forminput label="Suggested Meeting Time" name="when" value="{chosen_format}" placeholder="Please select available starting time above" readonly="true"></forminput> <forminput label="My Name" name="name" placeholder="John Smith"></forminput> <forminput label="My Organisation Name" name="orgname" placeholder=""></forminput> <forminput label="Email" name="email" placeholder="name@company.com" isrequired="" type="email"></forminput> <forminput label="Website" type="website" name="website" placeholder="www.yourwebsite.com"></forminput> <forminput label="Telephone" type="telephone" name="telephone" placeholder=""></forminput> <formtextarea label="Comments" rows="6" name="comments"></formtextarea> <formselect label="Location" name="location" placeholder="" options="{[{label:\'Duo Design Offices\',value:\'Duo Design Offices\'},{label:\'Our Offices\',value:\'Our Offices\'}]}"></formselect> <input type="submit" value="Send a Meeting Request" class="btn btn-primary pull-right"> </form> </div> </div> </div>', 'availability-cal .calbox { border: 1px solid #eee; margin: 15px 0px; } availability-cal .calbox datepicker { display: block; padding: 10px; } availability-cal .calbox datepicker table { width: 100%; } availability-cal .calbox datepicker table td, availability-cal .calbox datepicker table th { text-align: center; } availability-cal .calday.event { background: rgba(133,184,208,0.3); } availability-cal .calday.inactive { opacity: 0.2; -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=20)"; filter: alpha(opacity=20); } availability-cal .calday.active { background: #ff5a5f; } availability-cal .hours { border-bottom: 1px solid #ddd; } availability-cal .hours.event { background: rgba(133,184,208,0.3); } availability-cal .hours.chosen { background: #85b8d0; } availability-cal .busy { background: rgba(133,184,208,0.3); float: left; width: 15px; height: 15px; margin: 5px 5px 5px 10px; }', '', function(opts) {
this.duoreform = Math.round((4872987492 + new Date().getTime()) / 1000);

this.on('mount', function() {
  this.events = [];
  this.opening = [8, 9, 10, 11, 12, 13, 14, 15, 16];
  this.today = new Date(new Date().setDate(new Date().getDate() + 1));
  return this.getMonth();
});

this.handledatechange = (function(_this) {
  return function(date) {
    _this.today = date;
    _this.update();
    return _this.getMonth();
  };
})(this);

this.dateformat = (function(_this) {
  return function(date) {
    return date.getFullYear() + "-" + (1 + date.getMonth()) + "-" + date.getDate();
  };
})(this);

this.timeformat = (function(_this) {
  return function(date) {
    return date.getHours() + ":00";
  };
})(this);

this.monthbegin = (function(_this) {
  return function(date) {
    var dt;
    dt = new Date(date);
    return new Date(dt.setDate(1));
  };
})(this);

this.monthend = (function(_this) {
  return function(date) {
    var dt;
    dt = new Date(date);
    return new Date(new Date(dt.setMonth(dt.getMonth() + 1)).setDate(0));
  };
})(this);

this.getMonth = (function(_this) {
  return function() {
    var end, start;
    if (_this.month === _this.today.getMonth()) {
      return;
    }
    _this.month = _this.today.getMonth();
    start = _this.dateformat(_this.monthbegin(_this.today));
    end = _this.dateformat(_this.monthend(_this.today));
    return _this.getBusy(start, end);
  };
})(this);

this.getBusy = (function(_this) {
  return function(start, end) {
    var xhr;
    xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function() {
      var events;
      if (xhr.readyState === 4) {
        events = JSON.parse(xhr.responseText).data;
        _this.events = events.map(function(ev) {
          return {
            start: new Date(ev.start),
            end: new Date(ev.end)
          };
        });
        return _this.update();
      }
    };
    xhr.open('GET', "/duocms/api/gcal/events?start=" + start + "&end=" + end, true);
    return xhr.send();
  };
})(this);

this.choosetime = (function(_this) {
  return function(hr) {
    if (_this.hourfree(hr) === "") {
      _this.chosen = new Date(new Date(_this.today).setHours(hr));
      _this.chosen_format = _this.dateformat(_this.chosen) + " " + _this.timeformat(_this.chosen);
      return _this.update();
    }
  };
})(this);

this.hourfree = (function(_this) {
  return function(hr) {
    var ev, i, len, ref;
    if (!hr) {
      return "";
    }
    if (_this.chosen && _this.today.toDateString() === _this.chosen.toDateString() && 0 + hr === 0 + _this.chosen.getHours()) {
      return "chosen";
    }
    ref = _this.events;
    for (i = 0, len = ref.length; i < len; i++) {
      ev = ref[i];
      if (_this.today.toDateString() === ev.start.toDateString() && ev.start.getHours() <= hr && ev.end.getHours() >= hr) {
        return "event";
      }
    }
    return "";
  };
})(this);

this.datestyle = (function(_this) {
  return function(date) {
    var ev, i, len, ref;
    if (date.getMonth() !== _this.month || date < new Date() || date.getDay() === 6 || date.getDay() === 0) {
      return "inactive";
    }
    ref = _this.events;
    for (i = 0, len = ref.length; i < len; i++) {
      ev = ref[i];
      if (date.toDateString() === ev.start.toDateString() && ev.start.getHours() <= 16 && ev.end.getHours() >= 8) {
        return "event";
      }
    }
    return "";
  };
})(this);
});
    
  